import React from "react";
import PageHeader from "../../components/PageHeader";
import landingImage from "../../images/AzeemResume.png";
import { motion } from "framer-motion";

const Resume = ({ brand }) => {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center", // Center content horizontally
      textAlign: "center",
    },
    landingImage: {
      maxWidth: "100%", // Make sure the image doesn't exceed its container's width
    },
  };

  return (
    <section className="resume container" style={styles.container}>
      <PageHeader title="Resume" description="Uncover my expertise" />
      <motion.img
        className="landingImage"
        transition={{ delay: 1, duration: 1.5, ease: "easeInOut" }}
        style={styles.landingImage}
        src={landingImage}
        alt="Azeem Maniyar"
      />
      <p className="brand">{brand}</p>
    </section>
  );
};

export default Resume;
